<template>
  <div id="filters_col">
    <a
      data-toggle="collapse"
      href="#collapseFilters"
      aria-expanded="false"
      aria-controls="collapseFilters"
      id="filters_col_bt"
      >Filters
    </a>
    <div class="collapse show" id="collapseFilters">
      <div class="filter_type">
        <h6>Pincode</h6>

         <input 
          type="text"
          id="pincode"
          name="pincode"
          v-model="search.pincode"
          @blur="loadFilter"
          class="form-control"
        /> 
      </div>
       <div class="col-lg-4">
            <div class="form-group text-black">
              <vue-simple-suggest   
                v-model="search.location"
                display-attribute="name"
                value-attribute="url"
                :list="getSuggestionList"
                @select="getvalue($event)"
              ></vue-simple-suggest>

              <br />
              <i class="icon_pin_alt" @click="currentLoc()"></i>
            </div>
            </div>
      <div class="filter_type">
        <h6>Discount</h6>

        Min:
        <input
          type="number"
          id="min-discount"
          name="min-discount"
          class="form-control"
          v-model="search.mindiscount"
          min="0"
          max="100"
          @change="loadFilter"
          @blur="loadFilter"
        />
        Max:
        <input
          type="number"
          id="max-discount"
          name="max-discount"
          class="form-control"
          v-model="search.maxdiscount"
          min="0"
          max="100"
          @change="loadFilter"
          @blur="loadFilter"
        />
      </div>
      <div class="filter_type">
        <h6>Sub Categories</h6>
        <ul>
          <!--li>
                    <label class="container_check"
                      >All
                      <small>(945)</small>
                      <input type="checkbox" checked />
                      <span class="checkmark"></span>
                    </label>
                  </li-->

          <li
            v-for="(subcat, subindex) in search.subcategories"
            :key="subindex"
          >
            <label class="container_check"
              >{{ subcat.category }}
              <!--small>(45)</small-->
              <input
                type="checkbox"
                :value="subcat.id"
                v-model="subcat.id"
                @click="loadFilter"
              />
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div>

      <div class="filter_type">
        <h6>Rating</h6>
        <ul>
          <li>
            <label class="container_check"
              >Superb 9+ <small>(25)</small>
              <input
                type="checkbox"
                @click="loadFilter"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Very Good 8+ <small>(26)</small>
              <input
                type="checkbox"
                @click="loadFilter"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Good 7+ <small>(25)</small>
              <input
                type="checkbox"
                @click="loadFilter"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
          <li>
            <label class="container_check"
              >Pleasant 6+ <small>(12)</small>
              <input
                type="checkbox"
                @click="loadFilter"
                v-model="search.rating"
              />
              <span class="checkmark"></span>
            </label>
          </li>
        </ul>
      </div>
    </div>
    <!--/filters col-->
  </div>
</template>

        <script>
import API from "../services/index";
import { EventBus } from "@/EventBus.js";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
export default {
  created() {
    EventBus.$on("emittedData", (data) => {
      this.myOptions = this.categories = data.categories;
      this.mySubOptions = data.subcategories;
      this.search = {
        pincode: data.pincode,
        location: data.location,
        categories: data.selectedCategories,
        subcategories: data.subcategories,
      };
      console.log("left filter event manager");
      console.log("categories List" + data.categories);
      console.log("subcategories List" + data.subcategories);
      console.log("select categories " + data.selectedCategories);
      console.log("select subcategories " + data.subcategories);
      console.log("select pincode " + data.pincode);
      console.log("select location " + data.location);
    });
  },
  data() {
    //alert("reached in filter type 1");
    return {
      categories: [],
      search: {
        pincode: "",
        location: "",
        categories: [],
        subcategories: [],
        rating: "",
         range:0,
        geocodes:[]

      },
      myOptions: [],
      mySubOptions: [],
    };
  },
  beforeMount() {
    if (this.search.categories.length > 0) {
      this.setSubCategory();
    }
  },
  components: {VueSimpleSuggest},
  methods: {
    loadFilter() {},
    setSubCategory() {
      var formData = new FormData();
      formData.append("category_id", this.search.categories);
      API({
        method: "post",
        url: "/categories/get_idbased_categories",
        data: formData,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      })
        .then((res) => {
          this.search.subcategories = res.data.data;
          console.log(this.search.subcategories);
        })
        .catch((err) => {
          this.$swal("Error", err.response.data.error_description);
        });
    },
      getSuggestionList () {
      var i =[]
      var config = {
    headers: {
    'Content-Type' : 'application/x-www-form-urlencoded; charset=UTF-8'
}
}
      if (this.search.location.length >= 2) {
       return API.get(`https://location.securebrandtech.com/auto/api?q=${this.search.location}`,config)
          .then(function (response) {
        response.data.features.forEach(function (feature) {
            i.push(`${feature.properties.name} ${feature.properties.state} ${feature.properties.country} ${feature.properties.postcode?feature.properties.postcode:feature.properties.countrycode}`) 
            })
            var uniq = [ ...new Set(i) ];
            return uniq 
            
          })

          .catch(function (error) {
            console.log(error);
          });
      }
    },
     currentLoc() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.error = 'Geolocation is not supported.'
      }
    },
   showPosition(position){
  position.coords.latitude
  position.coords.longitude
  var location = [position.coords.latitude,position.coords.longitude]
  this.SuggestionList(location)
      
   }, 
   SuggestionList(location){
      var i = [];
      // if (this.search.location.length >= 2) {
         API.get(`https://location.securebrandtech.com/auto/api?q=india&lat=${location[0]}&lon=${location[1]}`
        )
          .then( (response)=> {
            response.data.features.forEach(function (feature) {
              i.push(
                feature.properties.name +
                  " " +
                  feature.properties.county?feature.properties.county:"" +
                  " " +
                  " " +
                  feature.properties.state?feature.properties.state:"" +
                  " " +
                  feature.properties.postcode?feature.properties.postcode:""
              );
            });
            var uniq = [...new Set(i)];
            this.search.location = uniq[1]        
          })

          .catch(function (error) {
            console.log(error);
          });
 },
  },
};
</script>